<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="84.949"
    height="66.226"
    xmlns:v="https://vecta.io/nano"
  >
    <defs>
      <clipPath id="A">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-375.535 -427.843)" />
      </clipPath>
      <clipPath id="B">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-388.788 -414.516)" />
      </clipPath>
      <clipPath id="C">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-381.3 -414.516)" />
      </clipPath>
      <clipPath id="D">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-375.461 -433.088)" />
      </clipPath>
      <clipPath id="E">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-361.32 -432.236)" />
      </clipPath>
      <clipPath id="F">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-389.603 -432.236)" />
      </clipPath>
    </defs>
    <g
      stroke-miterlimit="10"
      stroke-width="3"
      stroke="#41693d"
      fill="none"
      transform="translate(-458.133 -523.375)"
    >
      <path
        d="M0 0c-15.431 0-29.735-13.327-29.735-13.327S-15.431-26.653 0-26.653s29.588 13.326 29.588 13.326S15.431 0 0 0z"
        transform="matrix(1.333333 0 0 -1.333333 500.71333 552.06293)"
        clip-path="url(#A)"
      />
      <path
        d="M0 0a13.33 13.33 0 0 0-13.327-13.327A13.33 13.33 0 0 0-26.653 0a13.33 13.33 0 0 0 13.326 13.327A13.33 13.33 0 0 0 0 0z"
        transform="matrix(1.333333 0 0 -1.333333 518.384 569.83187)"
        clip-path="url(#B)"
      />
      <path
        d="M0 0a5.84 5.84 0 0 0-5.839-5.839A5.84 5.84 0 0 0-11.677 0a5.84 5.84 0 0 0 5.838 5.839A5.84 5.84 0 0 0 0 0z"
        transform="matrix(1.333333 0 0 -1.333333 508.4 569.83187)"
        clip-path="url(#C)"
      />
      <g stroke-linecap="round">
        <path
          d="M0 0v14.771"
          transform="matrix(1.333333 0 0 -1.333333 500.6152 545.06973)"
          clip-path="url(#D)"
        />
        <path
          d="M0 0l-10.013 10.013"
          transform="matrix(1.333333 0 0 -1.333333 481.7596 546.206)"
          clip-path="url(#E)"
        />
        <path
          d="M0 0l10.013 10.013"
          transform="matrix(1.333333 0 0 -1.333333 519.47067 546.206)"
          clip-path="url(#F)"
        />
      </g>
    </g>
  </svg>
</template>
